export default __webpack_public_path__ + "static/scam-latitude-protect-alert-5-fc63c47edcc3ee99ba6aef99f333eed6.webp";